import React, { useState, useMemo, useEffect, useRef } from 'react';

export default ({ children }: any) => {
  // 头部吸顶相关逻辑
  const [headerFixed, setHeaderFixed] = useState(false);
  useEffect(() => {
    const handleScroll = (event: any) => {
      if (event.target.className == "tea-layout__content dbi-topcharts-detail") {
        let scrollTop = event.srcElement.scrollTop;
        // 滚动判断数值开发调整
        if (scrollTop > 176) {
          setHeaderFixed(true);
        } else if (scrollTop < 170) {
          setHeaderFixed(false);
        }
      }
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, []);

  return (
    <div className="dbi-fixedheader">
      <div
        className={`dbi-topcharts-detail-fixedheader dbi-fixedheader-wrap ${headerFixed ? 'visiable' : ''
          }`}
      >
        {children}
      </div>
    </div>
  )
}

